module.exports = __webpack_public_path__ + "img/DVR16.51662a4a.png";